import { AxiosRequestConfig } from 'axios';

const BASE_URL = 'https://apiservices-pre.pt.internal.vodafone.com';

//TODO Review this solution
const baseURLInterceptor = (config: AxiosRequestConfig) => {
    // If the URL is absolute, replace known origins with apiservices, otherwise do nothing
    if (config.url && /^https?:\/\//.test(config.url)) {
        if (config.url.startsWith('http://localhost:9001')) {
            config.url = config.url.replace('http://localhost:9001', BASE_URL);
        } else if (config.url.startsWith('https://onex-mfe-dev.non-prod.pt-digital.engineering.vodafone.com')) {
            config.url = config.url.replace(
                'https://onex-mfe-dev.non-prod.pt-digital.engineering.vodafone.com',
                BASE_URL
            );
        }
        return config;
    }

    config.baseURL = BASE_URL;
    return config;
};

export default baseURLInterceptor;
